<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="card-small mb-4">
        <d-card-header class="border-bottom">
          <h6 class="m-0">{{ $t('fences.card.title') }}</h6>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <puzzle-fences-form ref="puzzleFencesForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <sidebar-actions
        :model.sync="puzzleFences"
        @save="save"
        @generate="generate"
      />
    </d-col>
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import PuzzleFencesForm from './PuzzleFencesForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_PUZZLE_FENCES_MODEL_, MODEL } from './PuzzleFencesModel';


export default {
  name: 'puzzle-fences-page',
  components: {
    PuzzleFencesForm,
    SidebarActions,
  },
  computed: {
    puzzleFences() {
      const { puzzleFences } = this.$store.state.fences;
      if (puzzleFences) {
        Events.$emit(_LOAD_PUZZLE_FENCES_MODEL_, puzzleFences);
        return puzzleFences;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    generate() {
      this.$refs.puzzleFencesForm.generate();
    },
    save() {
      this.$refs.puzzleFencesForm.save();
    },
  },
};
</script>
